import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export const guestTypeState = {
   name: 'campaign.guestTypes',
   url: '/guest-types',
   templateUrl: require('./guest-types.html'),
   controller: 'GuestTypesController as vm'
};

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(guestTypeState);
}
